import { create } from "zustand";

interface SafeAddProjectStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSafeAddProjectStore = create<SafeAddProjectStore>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
